import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=a87e8c20&scoped=true&"
import script from "./Agreements.vue?vue&type=script&lang=js&"
export * from "./Agreements.vue?vue&type=script&lang=js&"
import style0 from "./Agreements.vue?vue&type=style&index=0&id=a87e8c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e8c20",
  null
  
)

export default component.exports